import React from "react";
import { CheckCircle2 } from "lucide-react";

export const ServiceBreakdown = ({ service: s }) => (
  <article id={s.id} className={`service-breakdown ${s.id === "supply-chain" ? "supply-chain-breakdown" : ""}`} data-testid={`service-${s.id}`}>
    <div className="service-breakdown-heading">
      <span className="font-heading text-4xl font-extrabold text-brandred" data-testid={`service-number-${s.id}`}>{s.no}</span>
      <div className="min-w-0">
        <span className="service-breakdown-badge" data-testid={`service-tag-${s.id}`}>{s.badge}</span>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-navy mt-3" data-testid={`service-title-${s.id}`}>{s.title}</h2>
        <p className="text-muted-foreground mt-3" data-testid={`service-description-${s.id}`}>{s.desc}</p>
      </div>
    </div>
    <div className="mt-8 grid lg:grid-cols-2 gap-8">
      <div className="min-w-0">
        <h3 className="font-heading text-sm uppercase tracking-wider text-navy mb-3">Ticket Sizes & Criteria</h3>
        <table className="service-table" data-testid={`service-table-${s.id}`}>
          <caption className="sr-only">{s.title} — Ticket Sizes & Criteria</caption>
          <thead><tr><th scope="col">{s.productColumn || "Region / Product"}</th><th scope="col">Ticket Size</th><th scope="col">Criteria</th></tr></thead>
          <tbody>{s.rows.map((row, index) => <tr key={index} data-testid={`service-row-${s.id}-${index}`}>
            <td>{row.region}</td><td>{row.ticket}</td><td>{row.min}</td>
          </tr>)}</tbody>
        </table>
      </div>
      <div className="min-w-0">
        <h3 className="font-heading text-sm uppercase tracking-wider text-navy mb-3">Key Highlights</h3>
        <ul className="space-y-3" data-testid={`service-highlights-${s.id}`}>{s.highlights.map((highlight, index) => (
          <li key={highlight} className="flex items-start gap-2 text-sm" data-testid={`service-highlight-${s.id}-${index}`}><CheckCircle2 size={17} className="text-brandred mt-0.5 shrink-0" aria-hidden="true" />{highlight}</li>
        ))}</ul>
        <h3 className="font-heading text-sm uppercase tracking-wider text-navy mt-7 mb-3">Eligible Profiles</h3>
        <div className="flex flex-wrap gap-2" data-testid={`service-profiles-${s.id}`}>{s.profiles.map((profile, index) => <span key={profile} className="profile-chip" data-testid={`service-profile-${s.id}-${index}`}>{profile}</span>)}</div>
      </div>
    </div>
  </article>
);